const fe_locale = state => state.fe_locale

export default {
  fe_locale,
}
